<form [formGroup]="salesTypeForm">
  <div class="row">
    <div class="col-lg-6 mb-3">
      <input-field
        [requiredLabel]="true"
        [label]="'Code'"
        [type]="'text'"
        [placeholder]="'Enter Code'"
        [errormessage]="'Code is required'"
        [required]="true"
        formControlName="code"
      >
      </input-field>
    </div>
    <div class="col-lg-6 mb-3">
      <input-field
        [requiredLabel]="true"
        [label]="'Description'"
        [type]="'text'"
        [required]="true"
        [placeholder]="'Enter Description'"
        [errormessage]="'Description is required'"
        formControlName="description"
      >
      </input-field>
    </div>
    <div class="col-lg-6 mb-3">
      <input
        class="form-check-input"
        type="checkbox"
        formControlName="salesAllocationRules"
        id="sales-allocation-rules"
      />
      <label class="form-check-label ms-1" for="sales-allocation-rules"> Sales Allocation Rules </label>
    </div>
  </div>
</form>
